import { createContext } from 'react'

export const CashCountContext = createContext()
